/* WZ ad offer v2 (Meta ads only, ends 19 Oct 2026). Applies the ad codes and shows the ad price.
   Visitors who arrive from the offer ads (?shn_offer=1 or the SHN-AD discount link)
   get all three ad-only codes stacked on their cart:
   SHN-AD25-K7Q (25% full price), SHN-AD15-K7Q (extra 15%), SHN-AD10-K7Q (extra 10%).
   Safe to delete after 20 Oct 2026. */
(function () {
  if (window.__wzAdOffer) return;
  window.__wzAdOffer = true;
  var CODES = ['SHN-AD25-K7Q', 'SHN-AD15-K7Q', 'SHN-AD10-K7Q'];
  var KEY = 'wz_ad_offer';
  var END = Date.parse('2026-10-19T18:59:59Z');
  if (Date.now() > END) return;
  try {
    var q = new URLSearchParams(location.search);
    if (q.get('shn_offer') === '1' || /(^|;\s*)discount_code=SHN-AD/i.test(document.cookie)) {
      localStorage.setItem(KEY, String(END));
    }
    if (!localStorage.getItem(KEY)) return;
  } catch (e) { return; }

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var busy = false, again = false;

  function ensure() {
    if (busy) { again = true; return; }
    busy = true;
    nativeFetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c || !c.item_count) return;
        var have = (c.discount_codes || []).map(function (d) { return String(d.code || '').toUpperCase(); });
        var missing = CODES.filter(function (x) { return have.indexOf(x) < 0; });
        if (!missing.length) return;
        return nativeFetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: have.concat(missing).join(',') })
        });
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; setTimeout(ensure, 200); }
      });
  }

  var CART = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  window.fetch = function (input, init) {
    var p = nativeFetch(input, init);
    try {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      if (CART.test(u)) p.then(function () { setTimeout(ensure, 250); }, function () {});
    } catch (e) {}
    return p;
  };
  var xOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    try { if (CART.test(String(u))) this.addEventListener('load', function () { setTimeout(ensure, 250); }); } catch (e) {}
    return xOpen.apply(this, arguments);
  };
  /* before leaving for checkout, make sure codes are on the cart */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"], button[onclick*="checkout"]');
    if (t) ensure();
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ensure); else ensure();

  /* ---- Show the ad price on product pages and product cards ---- */
  var TIER = {"9252045095189":25,"9044419576085":25,"9198316454165":25,"8975275458837":25,"9252044669205":25,"9305875677461":25,"9483079287061":25,"9464348836117":25,"9305874432277":25,"9305875153173":25,"9464348901653":25,"9464348803349":25,"9365915304213":25,"9436970221845":25,"9436970123541":25,"9365915205909":25,"9373415801109":25,"9373415506197":25,"9373415604501":25,"9436969074965":25,"9436970156309":25,"9198316552469":25,"9283834937621":25,"9373415538965":25,"9497939083541":25,"9436970090773":25,"9484448530709":25,"9452631621909":25,"9484488802581":25,"9452636799253":25,"9373416784149":25,"9484448497941":25,"9515054006549":25,"9484448432405":25,"9373415735573":25,"9245989437717":25,"9579806982421":25,"9428857946389":25,"9436970254613":25,"9483084726549":25,"9413573476629":25,"9579808588053":25,"9595258962197":25,"9373415932181":25,"9413573542165":25,"9524905804053":25,"9595335278869":25,"9524908491029":25,"9579807965461":25,"9595331346709":25,"9579807342869":25,"9524915831061":25,"9515019305237":25,"9595343438101":25,"9595337015573":25,"9595262271765":25,"9583942369557":25,"9524911603989":25,"9595329773845":25,"9579812585749":25,"9579806261525":25,"9595341340949":25,"9579803050261":25,"9595000979733":25,"9579809898773":25,"9595338981653":25,"9579812421909":25,"9579806687509":25,"8650758881557":25,"9220392911125":25,"9220393107733":25,"9019815493909":25,"8979143360789":25,"9347223879957":25,"9283835134229":25,"9300155334933":25,"9044419608853":25,"9198316388629":25,"9464348737813":25,"8918590390549":25,"9373415866645":25,"9365915402517":25,"9283834609941":25,"9291088101653":25,"9283834806549":25,"9283835101461":25,"9464348868885":25,"9220392780053":25,"9464348705045":25,"9060274635029":25,"9365915435285":25,"9464349032725":25,"9464348770581":25,"9365915336981":25,"9282744877333":25,"9291087839509":25,"9373415571733":25,"9365915238677":25,"9464348999957":25,"9305875022101":25,"9019815592213":25,"9019815788821":25,"9416295088405":25,"9283835199765":25,"9044419870997":25,"9118490820885":25,"9019815461141":25,"9057308705045":25,"9373416030485":25,"9252044144917":25,"9044419936533":25,"9198316355861":25,"9118490919189":25,"9019815624981":25,"9300155826453":25,"9019815723285":25,"9339594670357":25,"9198316519701":25,"9300155597077":25,"9044420133141":25,"9198316257557":25,"8979143393557":25,"9121559970069":25,"9483085447445":25,"9220393042197":25,"8979143098645":25,"9305875448085":25,"9300155466005":25,"9220392976661":25,"9305874596117":25,"9198316290325":25,"8538497188117":25,"9483084759317":25,"9365915271445":25,"9220393140501":25,"9488399106325":25,"9283834642709":25,"8918590357781":25,"9488400154901":25,"9365915369749":25,"8538497122581":25,"9403557871893":25,"9220393271573":25,"8942749581589":25,"9283834675477":25,"8538497417493":25,"9509227168021":25,"8942749614357":25,"9252044964117":25,"8538497253653":25,"8979143426325":25,"8979143164181":25,"9282747564309":25,"8979143459093":25,"9305875284245":25,"8538496860437":25,"9245989798165":25,"9483085381909":25,"8538496696597":25,"9305875513621":25,"9291087806741":25,"9428857848085":25,"9252044636437":25,"9483085414677":25,"9245989830933":25,"9252044538133":25,"8975276867861":25,"9252044996885":25,"9413573509397":25,"9198316486933":25,"8942749548821":25,"8942749450517":25,"9428857389333":25,"9428857291029":25,"9252045193493":25,"8942749483285":25,"9282748416277":25,"9282745958677":25,"9282746646805":25,"8918589997333":25,"9282747007253":25,"9282748776725":25,"9282748023061":25,"8918590062869":15,"8918590161173":15,"8918590325013":15,"9019815657749":15,"9019815756053":15,"9044419510549":15,"9057338589461":15,"9058685878549":15,"9058686009621":15,"9058686140693":15,"9060274798869":15,"9118490886421":15,"9118491017493":15,"9118491083029":15,"9220393173269":15,"9245989339413":15,"9245989863701":15,"9245989896469":15,"9291087511829":15,"9291087708437":15,"9291087937813":15,"9300155662613":15,"9339594277141":15,"9339594572053":15,"9339594703125":15,"9347223814421":15,"9347224011029":15,"9403558822165":15,"9428857553173":15,"9476077912341":15,"9514548396309":15,"9514557014293":15,"9514562814229":15,"9514580312341":15,"9514581295381":15,"9514581655829":15,"9524904165653":15,"9530440286485":15,"9530440778005":15,"9530441990421":15,"9540848976149":15,"9019815428373":10,"9019815526677":10,"9044419445013":10,"9118490951957":10,"9118491050261":10,"9291088003349":10,"9300155531541":10,"9300155728149":10,"9300155760917":10,"9300155793685":10,"9339594309909":10,"9339594375445":10,"9339594539285":10,"9339594604821":10,"9403558134037":10,"9403558330645":10,"9403559280917":10,"9449445294357":10,"9535524012309":25,"9535529353493":25,"9535524864277":25,"9535523193109":25,"9535401427221":25,"9535525355797":25,"9535526568213":25,"9535501500693":25};
  var LABEL = { 25: 'extra 25% off', 15: 'extra 15% off', 10: 'extra 10% off' };

  function css() {
    if (document.getElementById('wz-offer-css')) return;
    var s = document.createElement('style');
    s.id = 'wz-offer-css';
    s.textContent =
      '#wz-offer-bar{background:#111;color:#fff;text-align:center;font-size:13px;line-height:1.4;padding:8px 12px;letter-spacing:.3px}' +
      '#wz-offer-bar b{font-weight:600}' +
      '.wz-offer-price{margin-top:4px;font-size:13px;line-height:1.35;color:#b3261e}' +
      '.wz-offer-price b{font-weight:700}' +
      '.wz-offer-price span{display:inline-block;margin-left:4px;color:#555;font-size:12px}' +
      '.wz-offer-price.wz-main{font-size:16px;margin:6px 0 4px}' +
      '.wz-offer-price.wz-main span{font-size:13px}';
    document.head.appendChild(s);
  }

  function bar() {
    if (document.getElementById('wz-offer-bar') || !document.body) return;
    var d = document.createElement('div');
    d.id = 'wz-offer-bar';
    d.innerHTML = '<b>Your ad discount is active.</b> Extra savings are applied automatically at checkout.';
    document.body.insertBefore(d, document.body.firstChild);
  }

  /* take the shown price text, e.g. "Rs.14,500.00 PKR" or "$52.00 USD", and return it with the number reduced */
  function cut(text, pct) {
    var m = String(text).match(/\d[\d.,]*/);
    if (!m) return null;
    var raw = m[0], dec = '', th = '';
    var last = raw.match(/[.,](\d{1,2})$/);
    if (last) { dec = raw.charAt(raw.length - last[1].length - 1); th = dec === '.' ? ',' : '.'; }
    else { th = raw.indexOf(',') > -1 ? ',' : (raw.indexOf('.') > -1 ? '.' : ''); }
    var n = parseFloat(raw.split(th || '\u0000').join('').replace(dec || '\u0000', '.'));
    if (!isFinite(n) || n <= 0) return null;
    var v = n * (100 - pct) / 100;
    var digits = last ? last[1].length : 0;
    var parts = v.toFixed(digits).split('.');
    var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th || ',');
    var out = int + (digits ? dec + parts[1] : '');
    return text.slice(0, m.index) + out + text.slice(m.index + raw.length);
  }

  function shownPrice(el) {
    var ins = el.querySelector('ins');
    var src = ins || el;
    return (src.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function pageProductId() {
    try { return String(window.ShopifyAnalytics.meta.product.id); } catch (e) { return null; }
  }

  function paint(el) {
    if (el.closest('.wz-offer-price')) return;
    var card = el.closest('[data-product-options]');
    var pid = null, main = false;
    if (card) {
      var cls = (card.className.match(/t4s-pr-(\d{6,})/) || [])[1];
      pid = cls || null;
      if (!pid) { try { pid = String(JSON.parse(card.getAttribute('data-product-options')).id); } catch (e) {} }
    } else {
      pid = pageProductId();
      main = true;
    }
    var next = el.nextElementSibling;
    var mine = next && next.classList && next.classList.contains('wz-offer-price') ? next : null;
    var pct = pid && TIER[pid];
    if (!pct) { if (mine) mine.remove(); return; }
    var txt = shownPrice(el);
    var key = pct + '|' + txt;
    if (mine && mine.getAttribute('data-k') === key) return;
    var price = cut(txt, pct);
    if (!price) { if (mine) mine.remove(); return; }
    if (!mine) {
      mine = document.createElement('div');
      mine.className = 'wz-offer-price' + (main ? ' wz-main' : '');
      el.parentNode.insertBefore(mine, el.nextSibling);
    }
    mine.setAttribute('data-k', key);
    mine.innerHTML = 'Your price: <b></b><span></span>';
    mine.querySelector('b').textContent = price;
    mine.querySelector('span').textContent = '(' + LABEL[pct] + ' at checkout)';
  }

  var queued = false;
  function scan() {
    queued = false;
    css(); bar();
    var els = document.querySelectorAll('.t4s-product-price');
    for (var i = 0; i < els.length; i++) { try { paint(els[i]); } catch (e) {} }
  }
  function later() { if (!queued) { queued = true; setTimeout(scan, 150); } }

  function startDisplay() {
    scan();
    try {
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          var t = list[i].target;
          if (t && t.nodeType === 1 && t.closest && t.closest('.wz-offer-price, #wz-offer-bar')) continue;
          later(); return;
        }
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startDisplay); else startDisplay();
})();
